import LoadEvent from '@/brain/event-map/load-event'

const state = {
  list: []
}

const getters = {
  LIST_ITEMS: (state) => state.list
}

const mutations = {
  SET_LIST: (state, { eventItems }) => { state.list = eventItems }
}

const actions = {
  LOAD_EVENT: LoadEvent
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/event-map/state/index.js